import { CheckBox, ICheckBoxOptions } from "devextreme-react/check-box";
import CheckboxProps from "interfaces/CheckboxProps";
import { dxCheckBoxOptions } from "devextreme/ui/check_box";
import "./styles/Controls.css";

export default function Checkbox(props: dxCheckBoxOptions & ICheckBoxOptions & CheckboxProps) {
  const { text, className, labelComponent, ...rest } = props;
  const getClassNames = () => {
    return `prom-control font-inter font-normal ${className ?? ""}`;
  };
  return (
    <div className="flex items-center">
      <CheckBox
        {...rest}
        className={getClassNames()}
        text={labelComponent ? "" : text}
      />
      {labelComponent && <div className="ml-2">{labelComponent}</div>}
    </div>
  );
}
